import { DomainNamesDateRangeFilter } from './@component/DomainNamesDateRangeFilter';

export const AddedDateFilter = () => {
  return (
    <DomainNamesDateRangeFilter
      startDateKey="added_date_start"
      endDateKey="added_date_end"
      label="Added date"
      logType="added date"
    />
  );
};
